import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiServiceBase } from './ApiServiceBase';
import { CountryModel } from '../common/Country';

@Injectable({
  providedIn: 'root'
})
export class CountryService extends ApiServiceBase {
  protected readonly path = 'country';
  
  get(): Observable<CountryModel[]> {
    return this.http.get<CountryModel[]>(this.getUrl());
  }
}
